import React from 'react';

export const TelephoneIcon2 = ({
  width = '22',
  height = '22',
  fill = '#0A3A86',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.6005 12.5221C11.2055 15.0421 5.09652 8.98811 7.50052 6.45811C8.96852 4.91311 7.31052 3.14811 6.39252 1.84911C4.66952 -0.585887 0.888521 2.77611 1.00252 4.91511C1.36552 11.6611 8.66252 19.6551 15.7285 18.9571C17.9385 18.7391 20.4785 14.7471 17.9435 13.2881C16.6755 12.5581 14.9345 11.1181 13.6005 12.5211M12.0005 1.00011C13.857 1.00011 15.6375 1.73761 16.9503 3.05037C18.263 4.36312 19.0005 6.1436 19.0005 8.00011M12.0005 5.00011C12.7962 5.00011 13.5592 5.31618 14.1218 5.87879C14.6845 6.4414 15.0005 7.20446 15.0005 8.00011"
        stroke={fill}
        strokeWidth="0.85"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6005 12.5221C11.2055 15.0421 5.09652 8.98811 7.50052 6.45811C8.96852 4.91311 7.31052 3.14811 6.39252 1.84911C4.66952 -0.585887 0.888521 2.77611 1.00252 4.91511C1.36552 11.6611 8.66252 19.6551 15.7285 18.9571C17.9385 18.7391 20.4785 14.7471 17.9435 13.2881C16.6755 12.5581 14.9345 11.1181 13.6005 12.5211M12.0005 1.00011C13.857 1.00011 15.6375 1.73761 16.9503 3.05037C18.263 4.36312 19.0005 6.1436 19.0005 8.00011M12.0005 5.00011C12.7962 5.00011 13.5592 5.31618 14.1218 5.87879C14.6845 6.4414 15.0005 7.20446 15.0005 8.00011"
        stroke="white"
        strokeOpacity="0.2"
        strokeWidth="0.85"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6005 12.5221C11.2055 15.0421 5.09652 8.98811 7.50052 6.45811C8.96852 4.91311 7.31052 3.14811 6.39252 1.84911C4.66952 -0.585887 0.888521 2.77611 1.00252 4.91511C1.36552 11.6611 8.66252 19.6551 15.7285 18.9571C17.9385 18.7391 20.4785 14.7471 17.9435 13.2881C16.6755 12.5581 14.9345 11.1181 13.6005 12.5211M12.0005 1.00011C13.857 1.00011 15.6375 1.73761 16.9503 3.05037C18.263 4.36312 19.0005 6.1436 19.0005 8.00011M12.0005 5.00011C12.7962 5.00011 13.5592 5.31618 14.1218 5.87879C14.6845 6.4414 15.0005 7.20446 15.0005 8.00011"
        stroke="white"
        strokeOpacity="0.2"
        strokeWidth="0.85"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
